<template>
  <div class="invoices">

    <!-- [ Header ] start -->
    <!--<Header :open="open" @showMenu="showMenu" @hideMenu="hideMenu" />-->
    <!-- [ Header ] end -->

    <div class="content">
      <!-- [ Menu ] start -->
      <!--<Menu :open="open" @companyName="companyName"/>-->
      <!-- [ Menu ] end -->

      <div class="wrap">

        <div class="wrap__center">

          <h3>Create Invoices</h3>
          <el-row>
            <el-col :span="12">
              <el-select v-model="companyClientListId" placeholder="Selecte client" size="small">
                <el-option v-for="item in this.companyClientList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  @click.native="changeClient(item.email)">
                </el-option>
              </el-select>

            </el-col>
            <el-col :span="12" style="text-align: right;">
              <el-button @click="handleAddTime" :disabled="!companyClientListId" type="primary" plain size="mini" icon="el-icon-plus">Add Time</el-button>
              <el-button @click="handleAddExpense" :disabled="!companyClientListId" type="primary" plain size="mini" icon="el-icon-plus">Add Expense</el-button>
            </el-col>
          </el-row>

          <el-form v-if="companyClientListId" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="150px" label-position="left">

            <!-- Form -->
            <el-row :gutter="80">
              <el-col :span="12">
                <el-form-item label="Invoice number" prop="invoiceNumber" size="mini">
                  <el-input v-model="ruleForm.invoiceNumber" placeholder="Invoice number" clearable></el-input>
                </el-form-item>

                <el-form-item label="Issue Date" prop="issueDate" size="mini">
                  <el-date-picker type="date"
                    format="d MMM yy"
                    placeholder="Issue Date"
                    v-model="ruleForm.issueDate"
                    value-format="ddMMyyyy"
                    style="width: 100%;">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="Due Date" prop="dueDate" size="mini">
                  <el-select v-model="ruleForm.dueDate" placeholder="Due Date" style="width: 100%;">
                    <el-option v-for="item in ruleForm.dueDateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="ruleForm.dueDate == 1" label="Custom Due Date" size="mini">
                  <el-input type="number" v-model="ruleForm.customDueDate" placeholder="Custom Due Date"></el-input>
                </el-form-item>

                <el-form-item label="Currency" prop="currency" size="mini">
                  <el-input v-model="ruleForm.currency" placeholder="Currency" disabled></el-input>
                </el-form-item>

                <el-form-item label="Customer Contact" prop="customerContact" size="mini">
                  <el-input v-model="ruleForm.customerContact" disabled placeholder="Customer Contact"></el-input>
                </el-form-item>

              </el-col>
              <el-col :span="12">

                <el-form-item label="Invoice Template" prop="invoiceTemplate" size="mini">
                  <el-select v-model="ruleForm.invoiceTemplate" placeholder="Invoice Template" style="width: 100%;">
                    <el-option v-for="item in ruleForm.invoiceTemplateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Amounts Are" prop="amountsAre" size="mini">
                  <el-select v-model="ruleForm.amountsAre" placeholder="Amounts Are" style="width: 100%;" clearable>
                    <el-option v-for="item in ruleForm.amountsAreList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Discount %" prop="discount" size="mini">
                  <el-input type="number" min="0" max="100" v-model="ruleForm.discount" @change="changeTable()" placeholder="Discount" clearable onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>

                <el-form-item label="Subject" prop="subject">
                  <el-input type="textarea" v-model="ruleForm.subject"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- Title -->
            <el-row :gutter="10" class="selectRowTitle">
              <el-col :span="3">
                <div class="selectRowTitle__item">Item</div>
              </el-col>
              <el-col :span="8">
                <div class="selectRowTitle__item">Short note</div>
              </el-col>
              <!-- <el-col :span="3">
                <div class="selectRowTitle__item">Time</div>
              </el-col> -->
              <!-- <el-col :span="3">
                <div class="selectRowTitle__item">Chart Of Account</div>
              </el-col> -->
              <el-col :span="2">
                <div class="selectRowTitle__item">Qty</div>
              </el-col>
              <el-col :span="2">
                <div class="selectRowTitle__item">Unit Price</div>
              </el-col>
              <el-col :span="2">
                <div class="selectRowTitle__item">Discount %</div>
              </el-col>
              <el-col :span="3">
                <div class="selectRowTitle__item">Taxes</div>
              </el-col>
              <el-col :span="2">
                <div class="selectRowTitle__item">Amount</div>
              </el-col>
              <el-col :span="2"></el-col>
            </el-row>

            <!-- Add row for table -->
            <el-form :model="selectRow" :rules="rulesRow" ref="selectRow" label-width="0px" class="demo-ruleForm">

              <el-row :gutter="10">
                <el-col :span="3">
                  <el-form-item prop="typeId" size="mini">
                    <el-select v-model="selectRow.typeId" placeholder="Select item" size="mini" style="width: 100%;">
                      <el-option v-for="item in typeList"
                        :key="item.serviceIndex"
                        :label="item.name"
                        :value="item.id"
                        @click.native="changeType(item.name, item.projectTaxId)">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="notes" size="mini">
                    <el-input v-model="selectRow.notes" placeholder="Short note" size="mini" clearable></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="3">
                  <div style="display: flex;">
                    <el-input v-model="selectRow.hoursSpent" type="number" placeholder="Hours" size="mini"></el-input>:
                    <el-input v-model="selectRow.minutesSpent" type="number" placeholder="Minutes" size="mini"></el-input>
                    <el-select v-model="selectRow.minutesSpent" placeholder="Minutes" size="mini" style="width: 100%;" filterable>
                      <el-option v-for="item in minutesList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col> -->
                <!-- <el-col :span="3">
                  <el-form-item prop="chartOfAccountId" size="mini">
                    <el-select v-model="selectRow.chartOfAccountId" placeholder="Chart Of Account" size="mini" style="width: 100%;" filterable>
                      <el-option v-for="item in ruleForm.chartOfAccountList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col :span="2">
                  <el-form-item prop="qty" size="mini">
                    <el-input type="number" v-model="selectRow.qty" @keyup.native="changeCalc()" placeholder="Quantity" size="mini" clearable onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item prop="amount" size="mini">
                    <el-input type="number" v-model="selectRow.amount" @keyup.native="changeCalc()" placeholder="Unit Price" size="mini" clearable onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item size="mini">
                    <el-input type="number" v-model="selectRow.discount" @keyup.native="changeCalc()" placeholder="Discount" size="mini" clearable onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item prop="taxes" size="mini">
                    <el-select v-model="selectRow.taxes" placeholder="Taxes" size="mini" style="width: 100%;">
                      <el-option v-for="item in ruleForm.taxesList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        @click.native="changeTaxes(item.id)">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item size="mini">
                    <el-input disabled type="number" v-model="selectRow.amountSum" placeholder="Amount" size="mini"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-button @click="createRow('selectRow')" type="primary" plain size="mini" style="width: 100%;">Add</el-button>
                </el-col>
              </el-row>

            </el-form>

            <!-- Table -->
            <el-row>
              <el-col :span="24">
                <el-table
                  :data="tableList.filter(data => !search || data.projectTaskName.toLowerCase().includes(search.toLowerCase()))"
                  style="width: 100%">
                  <el-table-column
                    label="Item"
                    prop="typeName"
                    sortable>
                  </el-table-column>
                  <el-table-column
                    label="Task Name"
                    prop="projectTaskName"
                    sortable>
                  </el-table-column>
                  <el-table-column
                    label="Short note">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.notes" placeholder="Short note" size="mini"></el-input>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    label="Time"
                    prop="time">
                  </el-table-column> -->
                  <!-- <el-table-column
                    label="Time">
                    <template slot-scope="scope">
                      <div v-if="scope.row.type != 'Task Fixed Rate' && scope.row.type != 'Expense' && scope.row.type != 'Type Cast'" style="display: flex;">
                        <el-input v-model="scope.row.hoursSpent" disabled type="number" placeholder="Hours" size="mini"></el-input>:
                        <el-input v-model="scope.row.minutesSpent" type="number" placeholder="Minutes" size="mini"></el-input>
                        <el-select v-model="scope.row.minutesSpent" placeholder="Minutes" size="mini" style="width: 100%;" filterable>
                          <el-option v-for="item in minutesList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                  </el-table-column> -->
                  <!-- <el-table-column
                    label="Chart Of Account">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.chartOfAccountId" placeholder="Chart Of Account" size="mini" style="width: 100%;">
                        <el-option v-for="item in ruleForm.chartOfAccountList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="changeTable()">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    label="Qty">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.qty" @keyup.native="changeTable(scope.row)" placeholder="Quantity" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Unit Price">
                    <template slot-scope="scope">
                      <!-- <div v-if="scope.row.type == 'Task Rate/HR' || scope.row.type == 'User Rate/HR'" v-html="scope.row.amount"></div> -->
                      <el-input v-model="scope.row.amount" @keyup.native="changeTable(scope.row)" placeholder="Unit Price" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Discount %">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.discount" @keyup.native="changeTable(scope.row)" placeholder="Discount" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Taxes">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.taxes" placeholder="Taxes" size="mini" style="width: 100%;">
                        <el-option v-for="item in ruleForm.taxesList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="changeTable()">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Amount"
                    prop="amountSum">
                  </el-table-column>
                  <el-table-column
                    align="right">
                    <template slot="header" slot-scope="{}">
                      <el-input
                        v-model="search"
                        size="mini"
                        placeholder="Type to search"/>
                    </template>
                    <template slot-scope="scope">
                      <!-- <el-button
                        size="mini"
                        type="primary"
                        plain
                        @click="handleEdit(scope.$index, scope.row, scope)">Edit</el-button> -->
                      <el-button
                        size="mini"
                        type="danger"
                        plain
                        @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>

            <!-- Footer -->
            <el-row type="flex" justify="end">
              <el-col :span="10">
                <div class="price">
                  <div v-if="ruleForm.amountsAre == 1" class="price__item">
                    <div>Includes Tax of</div>
                    <div>{{taxInclusive || '0.00'}}</div>
                  </div>
                  <div class="price__item price__item_border">
                    <div>Total Discount</div>
                    <div>{{totalDiscount || '0.00'}}</div>
                  </div>
                  <div class="price__item">
                    <div>Subtotal</div>
                    <div>{{ruleForm.subtotal || '0.00'}}</div>
                  </div>
                  <div v-if="ruleForm.amountsAre == 0" class="price__item">
                    <div>+ Tax of</div>
                    <div>{{taxExclusive || '0.00'}}</div>
                  </div>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" style="background: #e3e4e6;">
                <el-row type="flex" justify="space-between" style="margin-bottom: 0px;">
                  <el-col :span="4" class="createInvoice">
                    <el-button type="success" @click="submitForm('ruleForm')">Create Invoice</el-button>
                  </el-col>

                  <el-col :span="10">
                    <div class="amount">
                      <div>Total Amount: </div>
                      <div>{{totalAmount}} {{ruleForm.currency}}</div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

          </el-form>

        </div>

      </div>
    </div>

    <!-- [ Modal form Add Time ] start -->
    <sweet-modal blocking ref="addTime" class="modal">
      <h1 class="modal__title">Add Time</h1>

      <el-table
        ref="multipleTable"
        :data="tableDataTimeList"
        style="width: 100%"
        @selection-change="handleSelectionChangeAddTime">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          property="projectTaskName"
          label="Task Name">
        </el-table-column>
        <el-table-column
          property="notes"
          label="Short note">
        </el-table-column>
        <el-table-column
          property="projectTaskProgressActivityName"
          label="Activities">
        </el-table-column>
        <el-table-column
          property="projectTaskProgressAssignmentName"
          label="Assignments">
        </el-table-column>
        <el-table-column
          align="right"
          property="time"
          label="Time">
        </el-table-column>
        <el-table-column
          align="right"
          property="amount"
          label="Amount">
        </el-table-column>
      </el-table>

      <el-row type="flex" justify="end" style="margin-top: 20px;">
        <el-col :span="4">
          <el-button @click="closeModalTime" type="primary" plain size="mini">Add</el-button>
        </el-col>
      </el-row>

    </sweet-modal>
    <!-- [ Modal form Add Time ] end -->

    <!-- [ Modal form Add Expense ] start -->
    <sweet-modal blocking ref="addExpense" class="modal">
      <h1 class="modal__title">Add Expense</h1>

      <el-table
        ref="multipleTable"
        :data="tableDataExpenseList"
        style="width: 100%"
        @selection-change="handleSelectionChangeAddExpense">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          property="projectTaskName"
          label="Task Name">
        </el-table-column>
        <el-table-column
          property="notes"
          label="Short note">
        </el-table-column>
        <el-table-column
          align="right"
          property="amount"
          label="Amount">
        </el-table-column>
      </el-table>

      <el-row type="flex" justify="end" style="margin-top: 20px;">
        <el-col :span="4">
          <el-button @click="closeModalExpense" type="primary" plain size="mini">Add</el-button>
        </el-col>
      </el-row>

    </sweet-modal>
    <!-- [ Modal form Add Expense ] end -->
  </div>
</template>

<script>
// import Header from '@/components/Header.vue'
// import Menu from '@/components/Menu.vue'
import InviteVendor from '@/components/vendors/InviteVendor.vue'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import _ from 'lodash';
import axios from 'axios'
export default {
  name: 'Invoices',
  components: {
    // Header,
    // Menu,
    InviteVendor,
    SweetModal,

  },
  computed: {
    directoriesCreateInvoices() {
      return this.$store.getters.getDirectoriesCreateInvoices
    },
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
    totalDiscount() {
      return this.ruleForm.totalDiscount
    },
    taxExclusive() {
      return this.ruleForm.taxesExc
    },
    taxInclusive() {
      return this.ruleForm.taxesInc
    },
    totalAmount() {
      return this.ruleForm.amountsAre == 0 ? (+this.ruleForm.subtotal + +this.taxExclusive).toFixed(2) : (+this.ruleForm.subtotal).toFixed(2)
    },
  },
  watch: {
    directoriesCreateInvoices(val) {
      this.companyClientList = val.companyClientList
      this.ruleForm.taxesList = val.projectTaxList
      this.typeList = val.companyInventoryItemList
      this.typeList.splice(0, 2)
      this.ruleForm.chartOfAccountList = val.companyChartOfAccountItemList

    },
    companyLayout(val) {
      this.ruleForm.currency = val.currency.code
      this.ruleForm.currencyId = val.currency.id
    },
    tableList(val) {
      this.changeTable()
    },
  },
  created() {
    this.$store.dispatch('getDirectoriesCreateInvoices', this.$route.query.projectId)
    this.$store.dispatch('getCompanyLayout')
  },
  data() {
    return {
      // open: false,
      companyNameSelect: '',

      companyClientListId: null,
      companyClientList: [],

      ruleForm: {
        invoiceNumber: '',
        issueDate: '',
        dueDate: '',
        customDueDate: '',
        dueDateList: [{
            label: 'Custom',
            value: '1',
          },{
            label: 'Upon Receipt',
            value: '-1',
          },{
            label: '7 Days',
            value: '7',
          },{
            label: '15 Days',
            value: '15',
          },{
            label: '30 Days',
            value: '30',
          },{
            label: '60 Days',
            value: '60',
        }],
        currency: '',
        currencyId: '',
        customerContact: '',
        invoiceTemplate: 1,
        invoiceTemplateList: [{
          label: 'Default Template',
          value: 1,
        }],
        taxesList: [],
        chartOfAccountList: [],
        amountsAre: 0,
        amountsAreList: [{
            label: 'Tax Exclusive',
            value: 0,
          },{
            label: 'Tax Inclusive',
            value: 1,
        }],
        discount: null,
        subject: '',

        totalDiscount: null,
        subtotal: null,
        taxesExc: null,
        taxesInc: null,
      },
      rules: {
        invoiceNumber: [
          { required: true, message: 'Please input Invoice Number', trigger: 'blur' },
        ],
        issueDate: [
          { required: true, message: 'Please select Issue Date', trigger: 'change' }
        ],
        dueDate: [
          { required: true, message: 'Please select Due Date', trigger: 'change' }
        ],
        currency: [
          { required: true, message: 'Please select Currency', trigger: 'change' }
        ],
        customerContact: [
          { required: true, message: 'Please select Customer Contact', trigger: 'change' }
        ],
        invoiceTemplate: [
          { required: true, message: 'Please select Invoice Template', trigger: 'change' }
        ],
        amountsAre: [
          { required: true, message: 'Please select Invoice Template', trigger: 'change' }
        ],
        subject: [
          { required: true, message: 'Please select Subject', trigger: 'blur' }
        ],
      },
      rulesRow: {
        typeId: [
          { required: true, message: 'Please input Type', trigger: 'blur' },
        ],
        notes: [
          { required: true, message: 'Please select Notes', trigger: 'change' }
        ],
        qty: [
          { required: true, message: 'Please select Quantity', trigger: 'change' }
        ],
        taxes: [
          { required: true, message: 'Please select Taxes', trigger: 'change' }
        ],
        amount: [
          { required: true, message: 'Please select Unit Price', trigger: 'change' }
        ],
        // chartOfAccountId: [
        //   { required: true, message: 'Please select Chart Of AccountId', trigger: 'change' }
        // ],
      },

      // Type
      typeList: [],

      minutesList: [
        { label: '00', value: 0}, { label: '01', value: 1}, { label: '02', value: 2}, { label: '03', value: 3}, { label: '04', value: 4}, { label: '05', value: 5}, { label: '06', value: 6},
        { label: '07', value: 7}, { label: '08', value: 8}, { label: '09', value: 9}, { label: '10', value: 10}, { label: '11', value: 11}, { label: '12', value: 12},
        { label: '13', value: 13}, { label: '14', value: 14}, { label: '15', value: 15}, { label: '16', value: 16}, { label: '17', value: 17}, { label: '18', value: 18},
        { label: '19', value: 19}, { label: '20', value: 20}, { label: '21', value: 21}, { label: '22', value: 22}, { label: '23', value: 23}, { label: '24', value: 24},
        { label: '25', value: 25}, { label: '26', value: 26}, { label: '27', value: 27}, { label: '28', value: 28}, { label: '29', value: 29}, { label: '30', value: 30},
        { label: '31', value: 31}, { label: '32', value: 32}, { label: '33', value: 33}, { label: '34', value: 34}, { label: '35', value: 35}, { label: '36', value: 36},
        { label: '37', value: 37}, { label: '38', value: 38}, { label: '39', value: 39}, { label: '40', value: 40}, { label: '41', value: 41}, { label: '42', value: 42},
        { label: '43', value: 43}, { label: '44', value: 44}, { label: '45', value: 45}, { label: '46', value: 46}, { label: '47', value: 47}, { label: '48', value: 48},
        { label: '49', value: 49}, { label: '50', value: 50}, { label: '51', value: 51}, { label: '52', value: 52}, { label: '53', value: 53}, { label: '54', value: 54},
        { label: '55', value: 55}, { label: '56', value: 56}, { label: '57', value: 57}, { label: '58', value: 58}, { label: '59', value: 59}, { label: '60', value: 60},
      ],

      // Select row
      selectRow: {
        itemId: null,
        notes: null,
        taxes: null,
        taxesValue: null,
        qty: 1,
        amount: null,
        amountSum: null,
        discount: null,
        discountSum: null,
        // chartOfAccountId: null,
      },

      // Main table
      tableList: [],
      search: '',

      // Add time
      tableDataTimeList: [],
      multipleSelectionAddTime: [],

      // Add Expense
      tableDataExpenseList: [],
      multipleSelectionAddExpense: [],
    }
  },
  methods: {
    changeTable(row) {
      let amountAll = 0
      let discountAll = 0
      let taxesExcAll = 0
      let taxesIncAll = 0
      for (let i = 0; i < this.tableList.length; i++) {
        // qty
        if (this.tableList[i].qty === null) this.tableList[i].qty = 1

        this.tableList[i].amountSum = (+this.tableList[i].amount - ((this.tableList[i].amount * this.tableList[i].discount) / 100)).toFixed(2)
        this.tableList[i].amountSum = (+this.tableList[i].amountSum * +this.tableList[i].qty).toFixed(2)
        this.tableList[i].discountSum = ((this.tableList[i].amount * this.tableList[i].discount) / 100).toFixed(2)
        this.tableList[i].taxesSumExc = 0
        this.tableList[i].taxesSumInc = 0

        let taxesValue = null
        for (let j = 0; j < this.ruleForm.taxesList.length; j++) {
          if (this.ruleForm.taxesList[j].id == this.tableList[i].taxes) {
            taxesValue = this.ruleForm.taxesList[j].value
          }
        }

        for (let k = 0; k < this.typeList.length; k++) {
          if (this.typeList[k].id == this.tableList[i].typeId) {
            this.tableList[i].typeName = this.typeList[k].name
          }
        }

        this.tableList[i].taxesSumExc = (+this.tableList[i].amountSum * taxesValue) / 100
        taxesExcAll += this.tableList[i].taxesSumExc

        this.tableList[i].taxesSumInc = +this.tableList[i].amountSum - ((+this.tableList[i].amountSum * 100) / (100 + taxesValue))
        taxesIncAll += this.tableList[i].taxesSumInc

        amountAll += +this.tableList[i].amountSum
        discountAll += +this.tableList[i].discountSum
      }

      this.ruleForm.subtotal = amountAll.toFixed(2)
      this.ruleForm.totalDiscount = discountAll.toFixed(2)
      this.ruleForm.taxesExc = taxesExcAll.toFixed(2)
      this.ruleForm.taxesInc = taxesIncAll.toFixed(2)

      if (!!this.ruleForm.discount && +this.ruleForm.subtotal > 0) {
        this.ruleForm.totalDiscount = (+this.ruleForm.totalDiscount + ((+this.ruleForm.subtotal * +this.ruleForm.discount) / 100)).toFixed(2)

        this.ruleForm.subtotal = (+this.ruleForm.subtotal - ((+this.ruleForm.subtotal * +this.ruleForm.discount) / 100)).toFixed(2)
      }
    },
    closeModalTime() {
      for (let i = 0; i < this.multipleSelectionAddTime.length; i++) {
        this.tableList.push(this.multipleSelectionAddTime[i])
      }
      this.$refs['addTime'].close()
    },
    closeModalExpense() {
      for (let i = 0; i < this.multipleSelectionAddExpense.length; i++) {
        this.tableList.push(this.multipleSelectionAddExpense[i])
      }
      this.$refs['addExpense'].close()
    },
    // showMenu() {
    //   this.open = true
    //   console.log('---', this.open);
    // },
    // hideMenu() {
    //   this.open = false
    //   console.log('---', this.open);
    // },
    // companyName(name) {
    //   console.log('---companyName', name);
    //   this.companyNameSelect = name
    // },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    changeTaxes(id) {
      this.ruleForm.taxesId = id
    },
    changeType(value, taxId) {
      this.selectRow.taxes = taxId
      this.selectRow.typeName = value
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();

          // this.ruleForm.dueDate
          if (this.ruleForm.customDueDate) {
            this.ruleForm.dueDate = this.ruleForm.customDueDate
          }

          if (this.ruleForm.discount == '') this.ruleForm.discount == null


          let list = [];
          this.tableList
          for (let i = 0; i < this.tableList.length; i++) {
            let obj = {
              projectTaskId: null,
              // ! projectTaskProgressId -> projectProgressId
              projectTaskProgressId: null,
              // ! projectTaskExpenseId -> projectExpenseId
              projectTaskExpenseId: null,

              // ! companyInventoryItemId -> typeId
              companyInventoryItemId: null,
              // typeName: null,
              // type: null,
              projectTaskCostType: null,
              // projectTaskName: null,
              notes: null,
              discount: null,
              discountSum: null,
              hoursSpent: null,
              minutesSpent: null,
              // ! quantity -> qty
              quantity: null,
              amount: null,
              amountSum: null,
              // ! projectTaxId -> taxes
              projectTaxId: null,
              // ! taxSumInclude -> taxesSumInc
              taxSumInclude: null,
              // ! taxSumExclude -> taxesSumExc
              taxSumExclude: null,
              // ! taxSumExclude -> companyChartOfAccountItemId
              // companyChartOfAccountItemId: null,
            }

            // if (this.tableList[i].hoursSpent) {
            //   obj.hoursSpent = this.tableList[i].hoursSpent
            // }
            // if (this.tableList[i].minutesSpent) {
            //   obj.minutesSpent = this.tableList[i].minutesSpent
            // }

            // obj.companyChartOfAccountItemId = this.tableList[i].chartOfAccountId

            if (this.tableList[i].projectTaskCostType == 1) {
              obj.projectTaskId = this.tableList[i].projectTaskId
            } else if (this.tableList[i].projectTaskCostType == 2 || this.tableList[i].projectTaskCostType == 3) {
              obj.projectTaskProgressId = this.tableList[i].id
            } else if (this.tableList[i].typeName == 'Expense') {
              obj.projectTaskExpenseId = this.tableList[i].id || null
            }

            if (this.tableList[i].qty === null) {
              obj.quantity = 1
            } else {
              obj.quantity = +this.tableList[i].qty
            }

            // obj.type = this.tableList[i].type
            obj.companyInventoryItemId = this.tableList[i].typeId
            // obj.typeName = this.tableList[i].typeName
            // obj.projectTaskName = this.tableList[i].projectTaskName
            obj.projectTaskCostType = this.tableList[i].projectTaskCostType || null
            obj.notes = this.tableList[i].notes
            obj.discount = +this.tableList[i].discount
            obj.discountSum = +this.tableList[i].discountSum
            obj.amount = this.tableList[i].amount
            obj.amountSum = +this.tableList[i].amountSum
            obj.projectTaxId = this.tableList[i].taxes
            obj.taxSumInclude = +this.tableList[i].taxesSumInc
            obj.taxSumExclude = +this.tableList[i].taxesSumExc


            list.push(obj)
          }

          axios
          .post(`/api/v1/projectBillSheet/create?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`, {
            customerCompanyClientId: this.companyClientListId,
            no: this.ruleForm.invoiceNumber,
            issueDate: this.ruleForm.issueDate,
            dueDate: this.ruleForm.dueDate,
            currencyId: this.ruleForm.currencyId,
            customerEmail: this.ruleForm.customerContact,
            projectInvoiceTemplateId: this.ruleForm.invoiceTemplate,
            includeTax: this.ruleForm.amountsAre,
            // projectTaxId: this.ruleForm.taxesId,
            discount: +this.ruleForm.discount,
            subject: this.ruleForm.subject,

            itemList: list,
          })
          .then(response => {
            this.notification("Success", "Add invoice", "success");
            this.$router.push(`/invoices?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`);
            loader.hide()
          })
          .catch(error => {
            loader.hide()
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    changeClient(email) {
      this.ruleForm.customerContact = email
    },
    changeCalc() {
      this.selectRow.amountSum = this.selectRow.amount
      this.selectRow.amountSum = (+this.selectRow.amount - ((this.selectRow.amount * this.selectRow.discount) / 100)).toFixed(2)
      this.selectRow.amountSum = (+this.selectRow.amountSum * +this.selectRow.qty).toFixed(2)
      this.selectRow.discountSum = ((this.selectRow.amount * this.selectRow.discount) / 100).toFixed(2)
    },
    handleEdit(index, row, scope) {
      console.log(index, row, scope);
    },
    handleDelete(index, row) {
      this.$confirm('This will permanently delete item? Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete'
        });

        this.tableList.splice(index, 1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    handleAddTime() {
      console.log('---DGIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII', this.companyLayout.projectTaxId);
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/projectBillSheet/directories?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&operation=createProjectTaskProgressItem`)
        .then(response => {
          console.log('---/projectBillSheet/directories', response.data)

          let taskProgressList = response.data.projectTaskProgressData
          let list = []

          for (let i = 0; i < taskProgressList.length; i++) {
            if (taskProgressList[i].projectTaskCostType == 1) {
              taskProgressList[i].amount = (taskProgressList[i].projectTaskTotalPrice).toFixed(2)
              taskProgressList[i].notes = taskProgressList[i].projectTaskName
              taskProgressList[i].taxes = null
              // taskProgressList[i].type = 'Task Fixed Rate'
              taskProgressList[i].typeName = 'Time'
              taskProgressList[i].typeId = null
              taskProgressList[i].discount = null
              taskProgressList[i].amountSum = taskProgressList[i].amount
              taskProgressList[i].discountSum = null
              taskProgressList[i].qty = 1
              // taskProgressList[i].chartOfAccountId = null

              for (let t = 0; t < this.typeList.length; t++) {
                if (this.typeList[t].serviceIndex == 2) {
                  taskProgressList[i].typeId = this.typeList[t].id
                }
              }

              // .taxes
              for (let x = 0; x < this.typeList.length; x++) {
                if (this.typeList[x].id == taskProgressList[i].typeId) {
                  taskProgressList[i].taxes = this.typeList[x].projectTaxId
                }
              }

              list.push(taskProgressList[i])
            } else {
              for (let j = 0; j < taskProgressList[i].projectTaskProgressList.length; j++) {
                if (taskProgressList[i].projectTaskCostType == 2) {
                  // taskProgressList[i].projectTaskProgressList[j].type = 'Task Rate/HR'
                  taskProgressList[i].projectTaskProgressList[j].projectTaskCostType = taskProgressList[i].projectTaskCostType
                } else {
                  // taskProgressList[i].projectTaskProgressList[j].type = 'User Rate/HR'
                  taskProgressList[i].projectTaskProgressList[j].projectTaskCostType = taskProgressList[i].projectTaskCostType
                }
                taskProgressList[i].projectTaskProgressList[j].typeName = 'Time'
                taskProgressList[i].projectTaskProgressList[j].typeId = null
                taskProgressList[i].projectTaskProgressList[j].discount = null
                taskProgressList[i].projectTaskProgressList[j].discountSum = null
                taskProgressList[i].projectTaskProgressList[j].qty = 1

                for (let t = 0; t < this.typeList.length; t++) {
                  if (this.typeList[t].serviceIndex == 2) {
                    taskProgressList[i].projectTaskProgressList[j].typeId = this.typeList[t].id
                  }
                }

                // .taxes
                for (let t = 0; t < this.typeList.length; t++) {
                  if (this.typeList[t].id == taskProgressList[i].projectTaskProgressList[j].typeId) {
                    taskProgressList[i].projectTaskProgressList[j].taxes = this.typeList[t].projectTaxId
                  }
                }

                taskProgressList[i].projectTaskProgressList[j].projectTaskName = taskProgressList[i].projectTaskName
                taskProgressList[i].projectTaskProgressList[j].notes = taskProgressList[i].projectTaskProgressList[j].title
                taskProgressList[i].projectTaskProgressList[j].amount = (taskProgressList[i].projectTaskProgressList[j].totalPrice).toFixed(2)
                taskProgressList[i].projectTaskProgressList[j].amountSum = taskProgressList[i].projectTaskProgressList[j].amount

                // Time
                let hours = (taskProgressList[i].projectTaskProgressList[j].hoursSpent.toString().length < 2) ? '0' + taskProgressList[i].projectTaskProgressList[j].hoursSpent : taskProgressList[i].projectTaskProgressList[j].hoursSpent
                let minutes = (taskProgressList[i].projectTaskProgressList[j].minutesSpent.toString().length < 2) ? '0' + taskProgressList[i].projectTaskProgressList[j].minutesSpent : taskProgressList[i].projectTaskProgressList[j].minutesSpent
                taskProgressList[i].projectTaskProgressList[j].time = hours + ':' + minutes

                list.push(taskProgressList[i].projectTaskProgressList[j])
              }
            }
          }

          console.log('---ПУШКА', list);

          if (this.tableList.length > 0) {
            var tempArrId = this.tableList.map(item => item.id);
            var tempArrProjectTaskId = this.tableList.map(item => item.projectTaskId);
            let delList = _.remove(list, (n) => {
              if (n.projectTaskCostType == 1) {
                return tempArrProjectTaskId.indexOf(n.projectTaskId) != -1;
              }
              if (n.projectTaskCostType == 2) {
                return tempArrId.indexOf(n.id) != -1;
              }
              if (n.projectTaskCostType == 3) {
                return tempArrId.indexOf(n.id) != -1;
              }
            });
          }

          this.tableDataTimeList = list

          this.$refs['addTime'].open()
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    handleAddExpense() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/projectBillSheet/directories?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&operation=createProjectTaskExpenseItem`)
        .then(response => {
          console.log('---/projectBillSheet/directories', response.data)
          // this.tableDataExpenseList = response.data

          let taskList = response.data.projectTaskList
          let expenseList = response.data.projectTaskExpenseList
          let list = []

          for (let i = 0; i < taskList.length; i++) {
            let taskListId = taskList[i].id
            for (let j = 0; j < expenseList.length; j++) {
              let expenseListId = expenseList[j].projectTaskId
              if (taskListId == expenseListId) {
                expenseList[j].projectTaskId = null
                expenseList[j].projectTaskName = taskList[i].name
                expenseList[j].projectTaskCostType = null
                expenseList[j].taxes = null
                // expenseList[j].type = 'Expense'
                expenseList[j].typeName = 'Expense'
                expenseList[j].typeId = null
                expenseList[j].discount = null
                expenseList[j].discountSum = null
                expenseList[j].amount = (expenseList[j].totalAmount).toFixed(2)
                expenseList[j].amountSum = expenseList[j].amount
                expenseList[j].qty = 1
                // expenseList[j].chartOfAccountId = null

                for (let t = 0; t < this.typeList.length; t++) {
                  if (this.typeList[t].serviceIndex == 1) {
                    expenseList[j].typeId = this.typeList[t].id
                  }
                }

                // .taxes
                for (let x = 0; x < this.typeList.length; x++) {
                  if (this.typeList[x].id == expenseList[j].typeId) {
                    expenseList[j].taxes = this.typeList[x].projectTaxId
                  }
                }

                list.push(expenseList[j])
              }
            }
          }

          for (let t = 0; t < list.length; t++) {
            if (list[t].notes.length > 50) {
              list[t].notes = list[t].notes.slice(0, 50)
            }
          }

          if (this.tableList.length > 0) {
            var tempArrId = this.tableList.map(item => item.id);
            let delList = _.remove(list, (n) => {
              return tempArrId.indexOf(n.id) != -1;
            });
          }

          this.tableDataExpenseList = list

          this.$refs['addExpense'].open()
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    createRow(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let obj = {
            typeId: this.selectRow.typeId,
            typeName: this.selectRow.typeName,
            // type: null,
            notes: this.selectRow.notes,
            hoursSpent: this.selectRow.hoursSpent,
            minutesSpent: this.selectRow.minutesSpent,
            taxes: this.selectRow.taxes,
            qty: this.selectRow.qty,
            amount: this.selectRow.amount,
            discount: this.selectRow.discount,
            discountSum: this.selectRow.discountSum,
            amountSum: this.selectRow.amountSum,
            // chartOfAccountId: this.selectRow.chartOfAccountId
          }
          // if (this.selectRow.typeName == 'Time') {
          //   obj.type = 'Type Cast'
          // }
          this.tableList.push(obj)

          this.$refs['selectRow'].resetFields();
          this.selectRow.typeId = null
          this.selectRow.hoursSpent = null
          this.selectRow.minutesSpent = null
          this.selectRow.discount = null
          this.selectRow.discountSum = null
          this.selectRow.amountSum = null
          this.selectRow.qty = 1
          // this.selectRow.chartOfAccountId = null
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleSelectionChangeAddTime(val) {
      this.multipleSelectionAddTime = val;
    },
    handleSelectionChangeAddExpense(val) {
      this.multipleSelectionAddExpense = val;
    },
  },
}
</script>

<style lang="scss" scoped>
.invoices {
  background: #f2f4f7;
  height: 100vh;
}

.content {
  display: flex;
  height: 100vh;
  padding-top: 50px;
}

// [ Wrapper ] start
.wrap {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 20px 10px 10px 10px;
  height: 100%;
  overflow-y: auto;

  &__center {
    min-width: 1300px;
    // padding-bottom: 20px;
    h3 {
      margin: 0;
      font-size: 14px;
      color: #909399;
      margin-bottom: 10px;
    }
  }
}
// [ Wrapper ] end

// [ Nav tree ] start
.nav-tree {
  padding-bottom: 10px;
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}
// [ Nav tree ] end

// [ Modal ] start
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}
.button{
  cursor: pointer;
}
// [ Modal ] end

.price {
  padding: 20px;
  font-weight: bold;
  &__item{
    display: flex;
    justify-content: space-between;
    padding: 4px;
    &_border{
      border-bottom: 1px solid #000;
    }
  }
}

.createInvoice {
  padding: 20px;
  font-size: 30px;
}

.amount {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  font-size: 30px;
  font-weight: bold;
}

.el-row {
  margin-bottom: 20px;
}

.selectRowTitle {
  font-size: 14px;
  font-weight: bold;
  color: #909399;
  &__item {
    padding-left: 10px;
  }
}
</style>

